import { gaPushEvent } from "../base.analytics";
import type { ReferralChannel, SharedContentType } from "../shareAttribution";

enum Event {
  SHARED_LINK_OPENED = "shared_link_opened",
}

/**
 * A visit arrived from a shared link: the top of the share → sign-up funnel
 * (`docs/viral-coefficient.md`).
 *
 * Fired at boot by `captureShareAttribution`, once per page load, for every
 * arrival: a signed-in reader and a device that already holds a credit count
 * too. `logged_in` separates the members from the prospects. `sharer_user_id`
 * is null for a shared conversation or poster, whose page never names its
 * owner, and for a damaged `shared` value.
 */
export function gaEventSharedLinkOpened(params: {
  kind: ReferralChannel;
  sharerUserId: string | null;
  contentType: SharedContentType;
  loggedIn: boolean;
  landingPath: string;
}) {
  gaPushEvent(Event.SHARED_LINK_OPENED, {
    share_kind: params.kind,
    sharer_user_id: params.sharerUserId,
    content_type: params.contentType,
    logged_in: params.loggedIn,
    landing_path: params.landingPath,
  });
}
